import api from "../helpers/interceptor";

// ####################  apis for  Quiz Module  #######

// ####################  Mentors #######


// File Upload
export const uploadFile = async (file, mediaType) => {
    const formData = new FormData();
    formData.append('media', file);
    formData.append('media_type', mediaType);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    
    return await api.post('/uploadFile', formData, config);
  };



// ---------Quiz list ---------
export const QuizListing = async (payload) => await api.get(`/quiz/getQuizList?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`);

// -------------Add Quiz ---------------
export const addQuiz = async (payload) => await api.post(`/quiz/createNewQuiz`, payload)

// Status and delete 
export const quizStatus = async (payload) => await api.put(`/quiz/updateQuizStatus`, payload)

// Add/ Edit  questions 
export const addQuestions = async (payload) => await api.post(`/quiz/addQuizQuestions`, payload)

//Edit Quiz
export const editQuiz = async (payload) => await api.put(`/quiz/editQuizDetails`, payload)

// Get Details 
export const getDetails = async (quizId) => await api.get(`/quiz/getQuizDetails?quiz_id=${quizId}`);

